import { render, staticRenderFns } from "./GroupsInfo.vue?vue&type=template&id=189c8bcd&scoped=true&"
import script from "./GroupsInfo.vue?vue&type=script&lang=js&"
export * from "./GroupsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c8bcd",
  null
  
)

export default component.exports